export default "__VITE_ASSET__DSSP2zVZ__"